// Phase 4 UI: read the funding-routing gate from the per-user flag snapshot written by auth.js
// (GET /api/production/feature-flags/mine). The registry default is ON, so an absent key reads ON;
// only an explicit false (admin turned the flag off) reads OFF.
export const FUNDING_ROUTING_FLAG = 'funding_routing_gate_enabled';

export function isFundingRoutingOn() {
  try {
    const flags = JSON.parse(localStorage.getItem('gc360_feature_flags') || '{}');
    return flags[FUNDING_ROUTING_FLAG] !== false;
  } catch (e) {
    return true;
  }
}
